import { render, staticRenderFns } from "./NPSCard.vue?vue&type=template&id=33feb13e&scoped=true"
import script from "./NPSCard.vue?vue&type=script&lang=js"
export * from "./NPSCard.vue?vue&type=script&lang=js"
import style0 from "./NPSCard.vue?vue&type=style&index=0&id=33feb13e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33feb13e",
  null
  
)

export default component.exports